<div 
    class="fixed w-full h-full inset-0 flex items-center justify-center bg-main-background bg-opacity-75 z-30 gap-4 overflow-y-auto"
    (click)="$event.preventDefault(); handleCloseStudentInfo();"
>
    <div class="w-full max-h-full max-w-screen-md flex flex-row gap-1 justify-center overflow-y-auto" (click)="$event.stopPropagation()">
        <div class="w-full h-full overfow-y-auto flex min-w-full bg-white p-10 rounded-md text-center shadow-lg overflow-y-auto">
            <form 
                (ngSubmit)="$event.preventDefault(); updateStudentInfo();"
                [formGroup]="studentInfoReviewForm"
                class="w-full flex flex-col items-center justify-start gap-4"
            >
                <div class="w-full flex flex-col gap-2 items-center justify-center pb-4 border-b border-orange-200">
                    <div class="w-full flex gap-2 items-center justify-between">                        
                        <h2 class="w-full oswald-font text-xl font-medium text-start text-nside-orange-400">
                            Behavioral Threat Assessment Identified.
                        </h2>
                        <button
                            class="p-1 rounded-full hover:bg-gray-100"
                            (click)="$event.preventDefault(); handleCloseStudentInfo();"
                        >
                            <lucide-icon [name]="icons.X" [size]="20" class="text-nside-gray-200"></lucide-icon>
                        </button>
                    </div>
                    <p class="w-full text-start">
                        Is this the correct student information?
                    </p>
                </div>
                <div class="w-full flex flex-col items-center gap-2 pb-4 border-b border-orange-200">
                    <div class="w-full flex items-center text-start">
                        <div class="w-44 flex items-center">
                            <p>SSID:</p>
                        </div>
                        <div class="w-full flex flex-col items-center">
                            <p class="w-full">{{ this.studentInfo?.student_identifier }}</p>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start">
                        <div class="w-44 flex items-center">
                            <p>First Name:</p>
                        </div>
                        <div class="w-full flex flex-col items-center">
                            <p class="w-full">{{ this.studentInfo?.first_name }}</p>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start">
                        <div class="w-44 flex items-center">
                            <p>Last Name:</p>
                        </div>
                        <div class="w-full flex flex-col items-center">
                            <p class="w-full">{{ this.studentInfo?.last_name }}</p>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start">
                        <div class="w-44 flex items-center">
                            <p>Date of Birth:</p>
                        </div>
                        <div class="w-full flex items-center">
                            <p class="w-full">{{ student_birthday_to_display }}</p>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start">
                        <div class="w-44 flex items-center">
                            <p>Grade:</p>
                        </div>
                        <div class="w-full flex flex-col items-center">
                            <input 
                                type="text"
                                formControlName="grade"
                                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2"
                            >
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start">
                        <div class="w-44 flex items-center">
                            <p>Gender:</p>
                        </div>
                        <div class="w-full flex items-center gap-2">
                            <p class="w-full">{{ this.studentInfo?.identified_gender }}</p>
                        </div>
                    </div>
                    <div class="w-full flex items-start text-start">
                        <div class="w-44 flex items-center">
                            <p>Physical Description:</p>
                        </div>
                        <div class="w-full flex flex-col items-center">
                            <textarea 
                                formControlName="physical_description"
                                rows="3"
                                class="block p-2 w-full text-sm text-gray-900 bg-gray-50 rounded border border-gray-300"
                                placeholder="Physical Description..."
                            ></textarea>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start">
                        <div class="w-44 flex items-center">
                            <p>Does the student have an IEP?</p>
                        </div>
                        <div class="w-full flex items-center gap-2">
                            <div>
                                <input type="radio" id="has_iep_yes" value="{{ this.yesNo.Yes }}" class="hidden peer"
                                    formControlName="has_iep">
                                <label for="has_iep_yes"
                                class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50 border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                                    Yes
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="has_iep_no" value="{{ this.yesNo.No }}" class="hidden peer"
                                    formControlName="has_iep">
                                <label for="has_iep_no"
                                class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50 border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                                    No
                                </label>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="studentInfoReviewForm.get('has_iep')!.value === '1'" class="w-full flex items-center text-start">
                        <div class="w-44 flex items-center">
                            <p>IEP Contacts (email address):</p>
                        </div>
                        <div class="w-full flex flex-col items-center">
                            <input 
                                type="text"
                                formControlName="iep_contact"
                                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2"
                                placeholder="E.g., johndoe@test.com, janedoe@test.com, ..."
                            >
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start">
                        <div class="w-44 flex items-center">
                            <p>Does the student have an IHP?</p>
                        </div>
                        <div class="w-full flex items-center gap-2">
                            <div>
                                <input type="radio" id="has_ihp_yes" value="{{ this.yesNo.Yes }}" class="hidden peer"
                                    formControlName="has_ihp"
                                >
                                <label for="has_ihp_yes"
                                class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50 border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                                    Yes
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="has_ihp_no" value="{{ this.yesNo.No }}" class="hidden peer"
                                    formControlName="has_ihp"
                                >
                                <label for="has_ihp_no"
                                class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50  border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                                    No
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start">
                        <div class="w-44 flex items-center">
                            <p>Does the student have a 504?</p>
                        </div>
                        <div class="w-full flex items-center gap-2">
                            <div>
                                <input type="radio" id="has_504_yes" value="{{ this.yesNo.Yes }}" class="hidden peer"
                                    formControlName="has_504"
                                >
                                <label for="has_504_yes"
                                class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50 border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                                    Yes
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="has_504_no" value="{{ this.yesNo.No }}" class="hidden peer"
                                    formControlName="has_504"
                                >
                                <label for="has_504_no"
                                class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50  border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                                    No
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="w-full flex flex-row gap-2 items-center justify-end">
                    <button 
                        (click)="$event.preventDefault(); handleCloseStudentInfo();"
                        class="py-1.5 w-20 rounded-md border border-nside-gray-400 oswald-font"
                    >
                        Close
                    </button>
                    <button
                        type="submit"
                        class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white"
                        [ngClass]="{
                            'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': this.studentInfoReviewForm.invalid,
                            'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': this.studentInfoReviewForm.valid
                        }"
                    >
                        Continue
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<popup-message 
    [type]="messageModal"
    (close)="resetMessageModal()"
    [message]="popupMessage"
></popup-message>

<div *ngIf="loading">
    <spinner></spinner>
</div>